import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { PrivateRoute } from "components/PrivateRoute";
import { useEffect } from "react";
import { authAPI } from "services/auth";
import { useProjectTheme } from "hooks/useProjectTheme";
import { PoolContextProvider } from "context";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useAppStore } from "store/appStore";
import { Admin } from "types/auth";
import { useAccount, useSwitchChain } from "wagmi";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useNetworksStore } from "store/networksStore";
import { isSolanaNetwork } from "types/networks";
const App = () => {
  const navigate = useNavigate();
  const [theme] = useProjectTheme();
  const { setAdmin } = useAppStore();
  const { address: account, chain } = useAccount();
  const { switchChain } = useSwitchChain();
  const { currentNetwork } = useNetworksStore();

  useEffect(() => {
    authAPI.refresh().then(
      (res) => setAdmin(res as Admin),
      () => {
        localStorage.removeItem("accessToken");

        authAPI.logout();

        navigate("/auth/sign-in");
      }
    );
  }, []);

  useEffect(() => {
    if (!account || isSolanaNetwork(currentNetwork)) return;

    if (currentNetwork && currentNetwork.chainId && (!chain || chain.id !== +currentNetwork.chainId)) {
      switchChain({ chainId: +currentNetwork.chainId });
    }
  }, [chain, account, currentNetwork]);

  return (
    <PoolContextProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline>
          <Routes>
            <Route path="auth/*" element={<AuthLayout />} />
            <Route
              path="admin/*"
              element={
                <PrivateRoute>
                  <AdminLayout />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Navigate to="/admin" replace />
                </PrivateRoute>
              }
            />
          </Routes>
        </CssBaseline>
      </ThemeProvider>
    </PoolContextProvider>
  );
};

export default App;
